// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"404":"9c43aaaa","598":"a198e763"}[chunkId] + ".chunk.js";
};